var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.64 22.7158H26M4.24 14L2 14.0587M4.24 14C4.24 15.7673 5.67269 17.2 7.44 17.2C9.20731 17.2 10.64 15.7673 10.64 14C10.64 12.2327 9.20731 10.8 7.44 10.8C5.67269 10.8 4.24 12.2327 4.24 14ZM11.5586 14.0588H26M15.0679 5.40165L2 5.40165M26 5.40165H22.64M2 22.7158H15.0679M21.84 22.8C21.84 24.5673 20.4073 26 18.64 26C16.8727 26 15.44 24.5673 15.44 22.8C15.44 21.0327 16.8727 19.6 18.64 19.6C20.4073 19.6 21.84 21.0327 21.84 22.8ZM21.84 5.2C21.84 6.96731 20.4073 8.4 18.64 8.4C16.8727 8.4 15.44 6.96731 15.44 5.2C15.44 3.43269 16.8727 2 18.64 2C20.4073 2 21.84 3.43269 21.84 5.2Z",
    stroke: "#363853",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.603eb4b9310d01bdb456e4dabad564c2.svg";
export { ForwardRef as ReactComponent };